import { useColor } from "@commonlibs";
import clsx from "clsx";
import { ColoredPaperRoot } from "./ColoredPaper.styles";
import { ColoredPaperProps } from "./ColoredPaper.types";
import { forwardRef } from "react";

const ColoredPaper = forwardRef(({ className, color: colorProp = "primary", ...rest }: ColoredPaperProps, ref) => {
    const color = useColor(colorProp);
    return <ColoredPaperRoot ref={ref} className={clsx("colored-paper", className)} background={color as string} {...rest} />;
});

export default ColoredPaper;
